export default __webpack_public_path__ + "static/data-6851b1466c030adc976c3e350213579d.png";